import { useState } from 'react';
import { deckService } from '../../queries';
import MemoryButton from '../memory-button';
import { Modal } from '../modal';
import { useUserStore } from '../../../Auth/stores/authStore';
import { toast } from '../../../../core/components/atoms/Toast';

const ModalCreateDeck = ({
  isOpen,
  onClose,
  onCallbackSuccess,
}: {
  isOpen: boolean;
  onClose: () => void;
  onCallbackSuccess: () => void;
}) => {
  const { user } = useUserStore();
  const [name, setName] = useState('');

  const userUuid = user?.memoryUserUuid;

  const handleCreateDeck = async () => {
    if (!userUuid) return;
    try {
      await deckService.create({
        title: name,
        userUuid,
      });
      toast({
        title: 'Deck criado com sucesso',
        variant: 'success',
      });
      onCallbackSuccess?.();
      onClose?.();
    } catch (error) {
      console.error(error);
      toast({
        title: 'Erro ao criar deck',
        message: 'Tente novamente mais tarde',
        variant: 'error',
      });
    }
  };

  if (!isOpen) return null;

  return (
    <Modal isOpen={isOpen} onClose={onClose} title='Criar Deck'>
      <div className='flex flex-col gap-4'>
        <div className='flex flex-col gap-2'>
          <label
            htmlFor='deck-name'
            className='text-md text-mono-color-darkest'
          >
            Digite o nome do Deck:
          </label>
          <input
            id='deck-name'
            className='border flex items-center overflow-hidden  rounded-md border-mono-color-light'
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </div>
        {/* <div>
          <label
            htmlFor='deck-name'
            className='text-md text-mono-color-darkest'
          >
            Selecione a cor do Deck:
          </label>
          <div>
            <ColorPicker color={colorSelected} setColor={setColorSelected} />
          </div>
        </div>
        <div className='flex flex-col gap-2'>
          <label
            htmlFor='deck-name'
            className='text-md text-mono-color-darkest'
          >
            Selecione o icone do Deck:
          </label>
          <div className='border grid max-h-[10rem] grid-cols-5 gap-2 overflow-x-auto rounded-md border-mono-color-light p-2'>
            {DISCIPLINES_ICONS.map((icon, index) => (
              <div
                key={index}
                onClick={() => setIconSelected(icon)}
                className={`flex h-12 w-12 cursor-pointer flex-col items-center justify-center rounded-md p-1 ${icon === iconSelected ? 'border-2 border-thin border-brand-color-primary-pure' : ''}`}
              >
                <img
                  src={icon}
                  alt='icon'
                  className='h-full w-full object-contain'
                />
              </div>
            ))}
          </div>
        </div> */}
        <div className='flex flex-row gap-2'>
          <MemoryButton
            label='Cancelar'
            variant='outline'
            className='w-full'
            onClick={onClose}
            allowReadOnly
          />
          <MemoryButton
            label='Salvar'
            variant='primary'
            className='w-full bg-color-brand-primary'
            onClick={handleCreateDeck}
          />
        </div>
      </div>
    </Modal>
  );
};

export default ModalCreateDeck;
